import axios from "axios";

// Counts in-flight axios requests and notifies subscribers.
let pending = 0;
const listeners = new Set();
const emit = () => listeners.forEach((fn) => fn(pending));

export const subscribeLoading = (fn) => {
  listeners.add(fn);
  fn(pending);
  return () => listeners.delete(fn);
};

let installed = false;
export const setupLoadingTracker = () => {
  if (installed) return;
  installed = true;
  const done = () => {
    pending = Math.max(0, pending - 1);
    emit();
  };
  axios.interceptors.request.use(
    (config) => {
      pending += 1;
      emit();
      return config;
    },
    (error) => {
      done();
      return Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    (response) => {
      done();
      return response;
    },
    (error) => {
      done();
      return Promise.reject(error);
    }
  );
};
